// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from './client';
import type { GetApiAdminStatsData, GetApiAdminStatsResponses, GetApiAdminBusinessesData, GetApiAdminBusinessesResponses, PostApiAdminBusinessesByIdApproveData, PostApiAdminBusinessesByIdApproveResponses, PostApiAdminBusinessesByIdRejectData, PostApiAdminBusinessesByIdRejectResponses, PostApiAdminBusinessesByIdDisableData, PostApiAdminBusinessesByIdDisableResponses, GetApiAdminRatingsData, GetApiAdminRatingsResponses, DeleteApiAdminRatingsByIdData, DeleteApiAdminRatingsByIdResponses, PostApiAdminRatingsBulkDeleteData, PostApiAdminRatingsBulkDeleteResponses, GetApiAdminBusinessesByIdData, GetApiAdminBusinessesByIdResponses, GetApiAdminDocumentsByIdData, GetApiAdminDocumentsByIdResponses, PostApiAdminBusinessesByIdRevertData, PostApiAdminBusinessesByIdRevertResponses, PostApiAdminSeedData, PostApiAdminSeedResponses, PostApiAttachmentsRatingByRatingIdData, PostApiAttachmentsRatingByRatingIdResponses, DeleteApiAttachmentsByIdData, DeleteApiAttachmentsByIdResponses, GetApiAttachmentsByIdData, GetApiAttachmentsByIdResponses, GetApiBusinessesData, GetApiBusinessesResponses, PostApiBusinessesData, PostApiBusinessesResponses, DeleteApiBusinessesByIdData, DeleteApiBusinessesByIdResponses, GetApiBusinessesByIdData, GetApiBusinessesByIdResponses, PutApiBusinessesByIdData, PutApiBusinessesByIdResponses, GetApiBusinessesByIdEmployeesData, GetApiBusinessesByIdEmployeesResponses, PostApiBusinessesByIdEmployeesData, PostApiBusinessesByIdEmployeesResponses, GetApiBusinessesByIdRatingsData, GetApiBusinessesByIdRatingsResponses, DeleteApiBusinessesByIdEmployeesByUserIdData, DeleteApiBusinessesByIdEmployeesByUserIdResponses, PutApiBusinessesByIdEmployeesByUserIdData, PutApiBusinessesByIdEmployeesByUserIdResponses, GetApiCustomerSearchData, GetApiCustomerSearchResponses, PostApiCustomerData, PostApiCustomerResponses, PutApiCustomerByIdData, PutApiCustomerByIdResponses, GetApiCustomerNamesData, GetApiCustomerNamesResponses, GetApiCustomerNamesByNameBusinessesData, GetApiCustomerNamesByNameBusinessesResponses, GetApiEmployeesMineData, GetApiEmployeesMineResponses, GetApiEmployeesOfBusinessByBusinessIdData, GetApiEmployeesOfBusinessByBusinessIdResponses, GetApiOnboardingCategoriesData, GetApiOnboardingCategoriesResponses, PostApiOnboardingRegisterData, PostApiOnboardingRegisterResponses, PostApiOnboardingUploadProofData, PostApiOnboardingUploadProofResponses, GetApiOnboardingDocumentsData, GetApiOnboardingDocumentsResponses, DeleteApiOnboardingDocumentsByIdData, DeleteApiOnboardingDocumentsByIdResponses, GetApiRatingsData, GetApiRatingsResponses, PostApiRatingsData, PostApiRatingsResponses, GetApiRatingsSuggestionsData, GetApiRatingsSuggestionsResponses, DeleteApiRatingsByIdData, DeleteApiRatingsByIdResponses, PutApiRatingsByIdData, PutApiRatingsByIdResponses, GetApiRatingsCustomerByCustomerNameData, GetApiRatingsCustomerByCustomerNameResponses, GetWeatherForecastData, GetWeatherForecastResponses } from './types.gen';
import { client as _heyApiClient } from './client.gen';
import { getApiAdminBusinessesResponseTransformer, getApiAdminRatingsResponseTransformer, getApiAdminBusinessesByIdResponseTransformer, postApiAttachmentsRatingByRatingIdResponseTransformer, getApiBusinessesResponseTransformer, postApiBusinessesResponseTransformer, getApiBusinessesByIdResponseTransformer, getApiBusinessesByIdRatingsResponseTransformer, getApiEmployeesMineResponseTransformer, getApiEmployeesOfBusinessByBusinessIdResponseTransformer, getApiOnboardingDocumentsResponseTransformer, getApiRatingsResponseTransformer, getApiRatingsCustomerByCustomerNameResponseTransformer, getWeatherForecastResponseTransformer } from './transformers.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const getApiAdminStats = <ThrowOnError extends boolean = false>(options?: Options<GetApiAdminStatsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiAdminStatsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Admin/stats',
        ...options
    });
};

export const getApiAdminBusinesses = <ThrowOnError extends boolean = false>(options?: Options<GetApiAdminBusinessesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiAdminBusinessesResponses, unknown, ThrowOnError>({
        responseTransformer: getApiAdminBusinessesResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Admin/businesses',
        ...options
    });
};

export const postApiAdminBusinessesByIdApprove = <ThrowOnError extends boolean = false>(options: Options<PostApiAdminBusinessesByIdApproveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiAdminBusinessesByIdApproveResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Admin/businesses/{id}/approve',
        ...options
    });
};

export const postApiAdminBusinessesByIdReject = <ThrowOnError extends boolean = false>(options: Options<PostApiAdminBusinessesByIdRejectData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiAdminBusinessesByIdRejectResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Admin/businesses/{id}/reject',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const postApiAdminBusinessesByIdDisable = <ThrowOnError extends boolean = false>(options: Options<PostApiAdminBusinessesByIdDisableData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiAdminBusinessesByIdDisableResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Admin/businesses/{id}/disable',
        ...options
    });
};

export const getApiAdminRatings = <ThrowOnError extends boolean = false>(options?: Options<GetApiAdminRatingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiAdminRatingsResponses, unknown, ThrowOnError>({
        responseTransformer: getApiAdminRatingsResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Admin/ratings',
        ...options
    });
};

export const deleteApiAdminRatingsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiAdminRatingsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteApiAdminRatingsByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Admin/ratings/{id}',
        ...options
    });
};

export const postApiAdminRatingsBulkDelete = <ThrowOnError extends boolean = false>(options?: Options<PostApiAdminRatingsBulkDeleteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiAdminRatingsBulkDeleteResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Admin/ratings/bulk-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getApiAdminBusinessesById = <ThrowOnError extends boolean = false>(options: Options<GetApiAdminBusinessesByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiAdminBusinessesByIdResponses, unknown, ThrowOnError>({
        responseTransformer: getApiAdminBusinessesByIdResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Admin/businesses/{id}',
        ...options
    });
};

export const getApiAdminDocumentsById = <ThrowOnError extends boolean = false>(options: Options<GetApiAdminDocumentsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiAdminDocumentsByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Admin/documents/{id}',
        ...options
    });
};

export const postApiAdminBusinessesByIdRevert = <ThrowOnError extends boolean = false>(options: Options<PostApiAdminBusinessesByIdRevertData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiAdminBusinessesByIdRevertResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Admin/businesses/{id}/revert',
        ...options
    });
};

export const postApiAdminSeed = <ThrowOnError extends boolean = false>(options?: Options<PostApiAdminSeedData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiAdminSeedResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Admin/seed',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postApiAttachmentsRatingByRatingId = <ThrowOnError extends boolean = false>(options: Options<PostApiAttachmentsRatingByRatingIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiAttachmentsRatingByRatingIdResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        responseTransformer: postApiAttachmentsRatingByRatingIdResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Attachments/rating/{ratingId}',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const deleteApiAttachmentsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiAttachmentsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteApiAttachmentsByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Attachments/{id}',
        ...options
    });
};

export const getApiAttachmentsById = <ThrowOnError extends boolean = false>(options: Options<GetApiAttachmentsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiAttachmentsByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Attachments/{id}',
        ...options
    });
};

export const getApiBusinesses = <ThrowOnError extends boolean = false>(options?: Options<GetApiBusinessesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiBusinessesResponses, unknown, ThrowOnError>({
        responseTransformer: getApiBusinessesResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Businesses',
        ...options
    });
};

export const postApiBusinesses = <ThrowOnError extends boolean = false>(options?: Options<PostApiBusinessesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiBusinessesResponses, unknown, ThrowOnError>({
        responseTransformer: postApiBusinessesResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Businesses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const deleteApiBusinessesById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiBusinessesByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteApiBusinessesByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Businesses/{id}',
        ...options
    });
};

export const getApiBusinessesById = <ThrowOnError extends boolean = false>(options: Options<GetApiBusinessesByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiBusinessesByIdResponses, unknown, ThrowOnError>({
        responseTransformer: getApiBusinessesByIdResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Businesses/{id}',
        ...options
    });
};

export const putApiBusinessesById = <ThrowOnError extends boolean = false>(options: Options<PutApiBusinessesByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutApiBusinessesByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Businesses/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiBusinessesByIdEmployees = <ThrowOnError extends boolean = false>(options: Options<GetApiBusinessesByIdEmployeesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiBusinessesByIdEmployeesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Businesses/{id}/employees',
        ...options
    });
};

export const postApiBusinessesByIdEmployees = <ThrowOnError extends boolean = false>(options: Options<PostApiBusinessesByIdEmployeesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostApiBusinessesByIdEmployeesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Businesses/{id}/employees',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiBusinessesByIdRatings = <ThrowOnError extends boolean = false>(options: Options<GetApiBusinessesByIdRatingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiBusinessesByIdRatingsResponses, unknown, ThrowOnError>({
        responseTransformer: getApiBusinessesByIdRatingsResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Businesses/{id}/ratings',
        ...options
    });
};

export const deleteApiBusinessesByIdEmployeesByUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiBusinessesByIdEmployeesByUserIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteApiBusinessesByIdEmployeesByUserIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Businesses/{id}/employees/{userId}',
        ...options
    });
};

export const putApiBusinessesByIdEmployeesByUserId = <ThrowOnError extends boolean = false>(options: Options<PutApiBusinessesByIdEmployeesByUserIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutApiBusinessesByIdEmployeesByUserIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Businesses/{id}/employees/{userId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiCustomerSearch = <ThrowOnError extends boolean = false>(options?: Options<GetApiCustomerSearchData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiCustomerSearchResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Customer/search',
        ...options
    });
};

export const postApiCustomer = <ThrowOnError extends boolean = false>(options?: Options<PostApiCustomerData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiCustomerResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Customer',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const putApiCustomerById = <ThrowOnError extends boolean = false>(options: Options<PutApiCustomerByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutApiCustomerByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Customer/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiCustomerNames = <ThrowOnError extends boolean = false>(options?: Options<GetApiCustomerNamesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiCustomerNamesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/CustomerNames',
        ...options
    });
};

export const getApiCustomerNamesByNameBusinesses = <ThrowOnError extends boolean = false>(options: Options<GetApiCustomerNamesByNameBusinessesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiCustomerNamesByNameBusinessesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/CustomerNames/{name}/businesses',
        ...options
    });
};

export const getApiEmployeesMine = <ThrowOnError extends boolean = false>(options?: Options<GetApiEmployeesMineData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiEmployeesMineResponses, unknown, ThrowOnError>({
        responseTransformer: getApiEmployeesMineResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Employees/mine',
        ...options
    });
};

export const getApiEmployeesOfBusinessByBusinessId = <ThrowOnError extends boolean = false>(options: Options<GetApiEmployeesOfBusinessByBusinessIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiEmployeesOfBusinessByBusinessIdResponses, unknown, ThrowOnError>({
        responseTransformer: getApiEmployeesOfBusinessByBusinessIdResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Employees/ofBusiness/{businessId}',
        ...options
    });
};

export const getApiOnboardingCategories = <ThrowOnError extends boolean = false>(options?: Options<GetApiOnboardingCategoriesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiOnboardingCategoriesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Onboarding/categories',
        ...options
    });
};

export const postApiOnboardingRegister = <ThrowOnError extends boolean = false>(options?: Options<PostApiOnboardingRegisterData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiOnboardingRegisterResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Onboarding/register',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postApiOnboardingUploadProof = <ThrowOnError extends boolean = false>(options?: Options<PostApiOnboardingUploadProofData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiOnboardingUploadProofResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Onboarding/upload-proof',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

export const getApiOnboardingDocuments = <ThrowOnError extends boolean = false>(options?: Options<GetApiOnboardingDocumentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiOnboardingDocumentsResponses, unknown, ThrowOnError>({
        responseTransformer: getApiOnboardingDocumentsResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Onboarding/documents',
        ...options
    });
};

export const deleteApiOnboardingDocumentsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiOnboardingDocumentsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteApiOnboardingDocumentsByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Onboarding/documents/{id}',
        ...options
    });
};

export const getApiRatings = <ThrowOnError extends boolean = false>(options?: Options<GetApiRatingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiRatingsResponses, unknown, ThrowOnError>({
        responseTransformer: getApiRatingsResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Ratings',
        ...options
    });
};

export const postApiRatings = <ThrowOnError extends boolean = false>(options?: Options<PostApiRatingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiRatingsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Ratings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getApiRatingsSuggestions = <ThrowOnError extends boolean = false>(options?: Options<GetApiRatingsSuggestionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiRatingsSuggestionsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Ratings/suggestions',
        ...options
    });
};

export const deleteApiRatingsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiRatingsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteApiRatingsByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Ratings/{id}',
        ...options
    });
};

export const putApiRatingsById = <ThrowOnError extends boolean = false>(options: Options<PutApiRatingsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutApiRatingsByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Ratings/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getApiRatingsCustomerByCustomerName = <ThrowOnError extends boolean = false>(options: Options<GetApiRatingsCustomerByCustomerNameData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiRatingsCustomerByCustomerNameResponses, unknown, ThrowOnError>({
        responseTransformer: getApiRatingsCustomerByCustomerNameResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/Ratings/customer/{customerName}',
        ...options
    });
};

export const getWeatherForecast = <ThrowOnError extends boolean = false>(options?: Options<GetWeatherForecastData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWeatherForecastResponses, unknown, ThrowOnError>({
        responseTransformer: getWeatherForecastResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/WeatherForecast',
        ...options
    });
};